import { Link } from "react-router-dom";
import { Zap, PlayCircle } from "lucide-react";

const CATEGORY_COLOR = {
    Music: "text-streetz-red",
    News: "text-streetz-red",
    "Street Talk": "text-streetz-red",
    Culture: "text-streetz-red",
};

export default function TrendingRail({ items = [] }) {
    return (
        <aside
            data-testid="trending-rail"
            className="col-span-12 md:col-span-4 bg-streetz-paper border border-streetz-line p-5 md:p-6 flex flex-col"
        >
            <div className="flex items-center justify-between mb-5 pb-4 border-b border-streetz-line">
                <div className="flex items-center gap-2">
                    <Zap className="w-5 h-5 text-streetz-yellow" />
                    <span className="overline text-white">TRENDING NOW</span>
                </div>
                <Link
                    to="/"
                    data-testid="trending-view-all-link"
                    className="overline text-streetz-yellow hover:underline"
                >
                    VIEW ALL
                </Link>
            </div>

            <ul className="flex flex-col gap-4">
                {items.slice(0, 4).map((it, i) => (
                    <li key={it.id || i} className="border-b border-streetz-line last:border-0 pb-4 last:pb-0">
                        <Link
                            to={`/article/${it.slug}`}
                            data-testid={`trending-item-${i}`}
                            className="flex gap-3 group"
                        >
                            <div className="relative w-24 h-20 bg-streetz-raised shrink-0 overflow-hidden">
                                {it.image_url ? (
                                    <img
                                        src={it.image_url}
                                        alt={it.title}
                                        className="w-full h-full object-cover"
                                    />
                                ) : null}
                                <div className="absolute inset-0 grid place-items-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <PlayCircle className="w-6 h-6 text-streetz-yellow" />
                                </div>
                            </div>
                            <div className="flex-1 min-w-0">
                                <div
                                    className={`overline ${
                                        CATEGORY_COLOR[it.category] || "text-streetz-red"
                                    }`}
                                >
                                    {(it.category || "MUSIC").toUpperCase()}
                                </div>
                                <h4 className="font-display uppercase text-base md:text-lg leading-tight mt-1 text-white group-hover:text-streetz-yellow line-clamp-2">
                                    {it.title}
                                </h4>
                                <span className="text-xs text-streetz-muted mt-1 block">
                                    {(it.views || 0).toLocaleString()} views
                                </span>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && (
                    <li className="text-sm text-streetz-muted">
                        Trending stories will appear here once published.
                    </li>
                )}
            </ul>
        </aside>
    );
}
